/*
 *   Copyright (c) 2022 Busy Human LLC
 *   All rights reserved.
 *   This file, its contents, concepts, methods, behavior, and operation  (collectively the "Software") are protected by trade secret, patent,  and copyright laws. The use of the Software is governed by a license  agreement. Disclosure of the Software to third parties, in any form,  in whole or in part, is expressly prohibited except as authorized by the license agreement.
 */
export function assertId(id) {
    if (!id) {
        throw new Error(`Firestore ID should not be nullish`);
    }
    if (id.indexOf("undefined") >= 0) {
        console.log(id);
        console.warn(`ID contains undefined, this is probably a bug`);
    }
    return id;
}
export function assertPath(_path) {
    if (!_path) {
        throw new Error(`Path should not be nullish`);
    }
    if (_path.indexOf("undefined") >= 0) {
        console.log(_path);
        console.warn(`Path contains undefined, this is probably a bug`);
    }
    return _path;
}
export function assertPathParts(...pathParts) {
    for (let i = 0; i < pathParts.length; i++) {
        assertPath(pathParts[i]);
    }
}
//# sourceMappingURL=firebase-assertions.js.map